import styled from 'styled-components';
import { color } from 'styles/colors';

export const container: any = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  > p,
  b {
    width: 100%;
    font-size: 0.9rem;
    text-align: left;
    font-weight: ${(props: any) => props.fontWeight};
  }

  > p {
    color: ${color.interface.darkgray};
  }

  > b {
    color: ${color.interface.greenSuperXtra};
  }
`;
